<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!--      <a-form-model-item label="观看数" prop="lookNum" >-->
      <!--        <a-input v-model="form.lookNum" placeholder="请输入观看数" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('video.videoNameIn')" prop="videoNameIn" >
        <a-input show-count v-model="form.videoNameIn" :placeholder="$t('video.inputVideoNameIn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('video.videoNameEn')" prop="videoNameEn" >
        <a-input show-count v-model="form.videoNameEn" :placeholder="$t('video.inputVideoNameEn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('video.videoNameCn')" prop="videoNameCn" >
        <a-input show-count v-model="form.videoNameCn" :placeholder="$t('video.inputVideoNameCn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('video.videoName')" prop="videoName" >
        <a-input show-count v-model="form.videoName" :placeholder="$t('video.inputVideoName')" />
      </a-form-model-item>


<!--      <a-form-model-item label="西班牙语剧名" prop="videoNameBm" >-->
<!--        <a-input show-count v-model="form.videoNameBm" placeholder="请输入西班牙语剧名" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('video.coverUrlIn')" prop="coverUrlIn" >
        <file-upload type="image" :value="form.coverUrlIn" :count="1" @change="coverHandle"></file-upload>


<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.coverUrlIn"-->
<!--          :showUploadList="false"-->
<!--          :beforeUpload="beforeUpload4"-->
<!--          :customRequest="handleChange4"-->
<!--        >-->
<!--          <div v-if="form.coverUrlIn" class="upload-image-wrapper">-->
<!--            <img :src="form.coverUrlIn" alt="logo" style="height:104px;max-width:300px"/>-->
<!--            <div v-if="uploadLoading4" class="upload-mask">-->
<!--              <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>-->
<!--            </div>-->
<!--          </div>-->
<!--            <div v-else>-->
<!--            <a-icon :type="uploadLoading4 ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">{{ $t('video.upload') }}</div>-->
<!--          </div>-->
<!--        </a-upload>-->
      </a-form-model-item>

      <a-form-model-item :label="$t('video.coverUrlEn')" prop="coverUrlEn" >
        <file-upload type="image" :value="form.coverUrlEn" :count="1" @change="coverHandleEn"></file-upload>

<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.coverUrlEn"-->
<!--          :showUploadList="false"-->
<!--          :beforeUpload="beforeUpload1"-->
<!--          :customRequest="handleChange1"-->
<!--        >-->
<!--          <div v-if="form.coverUrlEn" class="upload-image-wrapper">-->
<!--            <img :src="form.coverUrlEn" alt="logo" style="height:104px;max-width:300px"/>-->
<!--            <div v-if="uploadLoading1" class="upload-mask">-->
<!--              <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-else>-->
<!--            <a-icon :type="uploadLoading1 ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">{{ $t('video.upload') }}</div>-->
<!--          </div>-->
<!--        </a-upload>-->
      </a-form-model-item>
      <a-form-model-item :label="$t('video.coverUrlCn')" prop="coverUrlCn" >
        <file-upload type="image" :value="form.coverUrlCn" :count="1" @change="coverHandleCn"></file-upload>
<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.coverUrlCn"-->
<!--          :showUploadList="false"-->
<!--          :beforeUpload="beforeUpload2"-->
<!--          :customRequest="handleChange2"-->
<!--        >-->
<!--          <div v-if="form.coverUrlCn" class="upload-image-wrapper">-->
<!--            <img :src="form.coverUrlCn" alt="logo" style="height:104px;max-width:300px"/>-->
<!--            <div v-if="uploadLoading2" class="upload-mask">-->
<!--              <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-else>-->
<!--            <a-icon :type="uploadLoading2 ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">{{ $t('video.upload') }}</div>-->
<!--          </div>-->
<!--        </a-upload>-->
      </a-form-model-item>
      <a-form-model-item :label="$t('video.coverUrl')" prop="coverUrl" >
        <file-upload type="image" :value="form.coverUrl" :count="1" @change="coverHandleZhengchang"></file-upload>
<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.coverUrl"-->
<!--          :showUploadList="false"-->
<!--          :beforeUpload="beforeUpload"-->
<!--          :customRequest="handleChange"-->
<!--        >-->
<!--          <div v-if="form.coverUrl" class="upload-image-wrapper">-->
<!--            <img :src="form.coverUrl" alt="logo" style="height:104px;max-width:300px"/>-->
<!--            <div v-if="uploadLoading" class="upload-mask">-->
<!--              <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-else>-->
<!--            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">{{ $t('video.upload') }}</div>-->
<!--          </div>-->
<!--        </a-upload>-->
      </a-form-model-item>

<!--      <a-form-model-item label="西班牙语封面图" prop="coverUrlBm" >-->
<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.coverUrlBm"-->
<!--          :showUploadList="false"-->
<!--          :beforeUpload="beforeUpload3"-->
<!--          :customRequest="handleChange3"-->
<!--        >-->
<!--          <plus-outlined />-->
<!--          <div v-if="form.coverUrlBm" class="upload-image-wrapper">-->
<!--            <img :src="form.coverUrlBm" alt="logo" style="height:104px;max-width:300px"/>-->
<!--            <div v-if="uploadLoading3" class="upload-mask">-->
<!--              <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-else>-->
<!--            <a-icon :type="uploadLoading3 ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">上传</div>-->
<!--          </div>-->
<!--        </a-upload>-->
<!--      </a-form-model-item>-->

      <a-form-model-item :label="$t('video.totalNum')" prop="totalNum" >
        <a-input-number :min="0" v-model="form.totalNum"  style="width: 100%"  :placeholder="$t('video.inputTotalNum')" @change="validateFreeLimitNumOnTotalChange" />
      </a-form-model-item>
      <a-form-model-item :label="$t('video.tag')" prop="type" >
        <a-select :placeholder="$t('video.selectTag')" v-model="form.type">
          <a-select-option :key="0">{{ $t('video.no') }}</a-select-option>
          <a-select-option :key="1">{{ $t('video.new') }}</a-select-option>
          <a-select-option :key="2">{{ $t('video.hot') }}</a-select-option>
          <a-select-option :key="3">{{ $t('video.premiere') }}</a-select-option>
          <a-select-option :key="4">{{ $t('video.exclusive') }}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :label="$t('video.isRelease')" prop="isRelease" >
        <a-select :placeholder="$t('common.select')" @change="updateIsGo" v-model="form.isRelease">
          <a-select-option :key="0">{{ $t('common.no') }}</a-select-option>
          <a-select-option :key="1">{{ $t('common.yes') }}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item v-if="this.isGo=='0'" :label="$t('video.releaseTime')" prop="releaseTime" >
        <a-date-picker
          :allow-clear="true"
          size="default"
          v-model="form.releaseTime"
          :placeholder="$t('video.releaseTime')"
          value-format="YYYY-MM-DD HH:mm:ss"
          format="YYYY-MM-DD HH:mm:ss"
          show-time
          @change="handleReleaseTimeChange">
        </a-date-picker>
      </a-form-model-item>

      <a-form-model-item :label="$t('video.category')" prop="tagIds" >
        <!--        <a-input v-model="form.tagIds" placeholder="请输入标签ids" />-->
        <a-tree-select
          v-model="tagIds"
          style="width: 100%"
          :tree-data="treeData"
          tree-checkable
          :search-placeholder="$t('video.selectCategory')"
          @change="changeSelect"
        />
      </a-form-model-item>
      <!--      <a-form-model-item label="前多少集可以使用金币观看" prop="limitNum" >-->
      <!--        <a-input-number :min="0" v-model="form.limitNum" placeholder="请输入" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('video.freeLimitNum')" prop="freeLimitNum" >
        <a-input-number :min="0" :precision="0" style="width: 100%" v-model="form.freeLimitNum" :placeholder="$t('common.input')" @change="handleFreeLimitNumChange" />
      </a-form-model-item>

      <a-form-model-item :label="$t('video.adUnlockEnabled')" prop="adUnlockEnabled">
        <a-radio-group v-model="form.adUnlockEnabled">
          <a-radio :value="1">{{ $t('video.enable') }}</a-radio>
          <a-radio :value="0">{{ $t('video.disable') }}</a-radio>
        </a-radio-group>
        <div>{{ $t('video.adUnlockHint') }}</div>
      </a-form-model-item>
      <a-form-model-item :label="$t('video.freeSecond')" prop="freeSecond" >
        <a-input-number :min="0" :precision="0"  style="width: 100%"  v-model="form.freeSecond" :placeholder="$t('common.input')" @change="handleFreeLimitNumChange" />
      </a-form-model-item>
      <a-form-model-item :label="$t('video.diamondPrice')" prop="diamondPrice" >
        <a-input-number :min="0" :precision="0"  style="width: 100%"  v-model="form.diamondPrice" :placeholder="$t('common.input')" @change="handleDiamondPriceChange" />
      </a-form-model-item>
      <a-form-model-item :label="$t('video.discountPrice')" prop="discountPrice" >
        <a-input-number :min="0" v-model="form.discountPrice"  style="width: 100%"  :placeholder="$t('common.input')" @change="handleDiscountPriceChange" />
      </a-form-model-item>
      <!--      <a-form-model-item label="每集金币价格" prop="goldPrice" >-->
      <!--        <a-input-number :min="0" v-model="form.goldPrice" placeholder="请输入" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item :label="$t('video.introductionsIn')" prop="introductionsIn" >
        <a-textarea show-count :maxLength="500" v-model="form.introductionsIn" :placeholder="$t('video.inputIntroductionsIn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('video.introductionsEn')" prop="introductionsEn" >
        <a-textarea show-count :maxLength="500" v-model="form.introductionsEn" :placeholder="$t('video.inputIntroductionsEn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('video.introductionsCn')" prop="introductionsCn" >
        <a-textarea show-count :maxLength="500" v-model="form.introductionsCn" :placeholder="$t('video.inputIntroductionsCn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('video.introductions')" prop="introductions" >
        <a-textarea show-count :maxLength="500" v-model="form.introductions" :placeholder="$t('video.inputIntroductions')" />
      </a-form-model-item>


<!--      <a-form-model-item label="西班牙语简介" prop="introductionsBm" >-->
<!--        <a-textarea show-count :maxLength="500" v-model="form.introductionsBm" placeholder="请输入西班牙语简介" />-->
<!--      </a-form-model-item>-->


      <!--      <a-form-model-item label="备注" prop="remark" >-->
      <!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getVideo, addVideo, updateVideo } from '@/api/video/video'
import { listTag } from '@/api/video/tag'
import UploadFileToVOD from "@/utils/vod.js"
import { uploadCos } from '@/api/common/index'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      isGo: false,
      tagIds: [],
      // 表单参数
      form: {
        id: null,
        adUnlockEnabled: 0,

        lookNum: null,

        limitNum: null,

        diamondPrice: null,
        discountPrice: null,
        freeSecond: null,
        goldPrice: null,

        introductions: null,
        introductionsEn: null,
        introductionsCn: null,
        introductionsBm: null,
        introductionsIn: null,

        tagIds: null,

        totalNum: null,
        releaseTime: null,
        videoName: null,
        videoNameEn: null,
        videoNameCn: null,
        videoNameBm: null,
        videoNameIn: null,

        coverUrl: null,
        coverUrlEn: null,
        coverUrlCn: null,
        coverUrlBm: null,
        coverUrlIn: null,

        createTime: null,
        freeLimitNum: null,
        remark: null,
        isRelease: 1
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      uploadLoading: false,
      uploadLoading1: false,
      uploadLoading2: false,
      uploadLoading3: false,
      uploadLoading4: false,
      treeData: []
    }
  },
  filters: {
  },
  created () {

  },
  computed: {
    rules() {
      return {
        lookNum: [
          { required: true, message: this.$t('common.required') }
        ],
        limitNum: [
          { required: true, message: this.$t('common.required') }
        ],
        freeLimitNum: [
          { required: true, message: this.$t('video.freeLimitNumRequired') },
          { validator: this.validateFreeLimitNum, trigger: ['blur', 'change'] }
        ],
        tagIds: [
          { required: false, message: this.$t('common.required') }
        ],
        totalNum: [
          { required: true, message: this.$t('video.totalNumRequired') }
        ],
        releaseTime: [
          { required: false, message: this.$t('video.releaseTimeRequired') },
          { validator: this.validateReleaseTime, trigger: ['blur', 'change'] }
        ],
        videoName: [
          { required: true, message: this.$t('video.videoNameRequired') }
        ],
        videoNameEn: [
          { required: true, message: this.$t('video.videoNameEnRequired') }
        ],
        videoNameCn: [
          { required: true, message: this.$t('video.videoNameCnRequired') }
        ],
        // videoNameBm: [
        //   { required: true, message: '西班牙语剧名不能为空' }
        // ],
        videoNameIn: [
          { required: true, message: this.$t('video.videoNameInRequired') }
        ],
        introductions: [
          { max: 500, message: this.$t('video.introductionsMaxLength') }
        ],
        introductionsEn: [
          { max: 500, message: this.$t('video.introductionsMaxLength') }
        ],
        coverUrl: [
          { required: true, message: this.$t('video.coverUrlRequired') }
        ],
        coverUrlEn: [
          { required: true, message: this.$t('video.coverUrlEnRequired') }
        ],
        coverUrlCn: [
          { required: true, message: this.$t('video.coverUrlCnRequired') }
        ],
        // coverUrlBm: [
        //   { required: true, message: '西班牙语封面图不能为空' }
        // ],
        coverUrlIn: [
          { required: true, message: this.$t('video.coverUrlInRequired') }
        ],
        diamondPrice: [
          { validator: this.validateDiamondPrice, trigger: ['blur', 'change'] }
        ],
        discountPrice: [
          { validator: this.validateDiscountPrice, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
    // this.getAllList()
  },
  methods: {
    coverHandle(val) {
      this.form.coverUrlIn = val
    },
    coverHandleEn(val) {
      this.form.coverUrlEn = val;
    },
    coverHandleZhengchang(val) {
      console.log('val');
      console.log(val);
      this.form.coverUrl = val;
    },
    coverHandleCn(val) {
      this.form.coverUrlCn = val;
    },

    validateFreeLimitNum (rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback()
        return
      }
      if (this.form.totalNum !== null && this.form.totalNum !== undefined && value > this.form.totalNum) {
        callback(new Error(this.$t('video.freeLimitNumExceed')))
      } else {
        callback()
      }
    },
    validateFreeLimitNumOnTotalChange () {
      // 当总集数变化时，重新验证免费观看集数
      if (this.$refs.form && this.form.freeLimitNum !== null && this.form.freeLimitNum !== undefined) {
        this.$refs.form.validateField('freeLimitNum')
      }
    },
    handleFreeLimitNumChange () {
      // 当免费观看集数变化时，触发验证
      if (this.$refs.form) {
        this.$refs.form.validateField('freeLimitNum')
      }
    },
    validateDiamondPrice (rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback()
        return
      }
      // 原价不能小于优惠价格
      if (this.form.discountPrice !== null && this.form.discountPrice !== undefined && value < this.form.discountPrice) {
        callback(new Error(this.$t('video.diamondPriceLessThanDiscount')))
      } else {
        callback()
      }
    },
    validateDiscountPrice (rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback()
        return
      }
      // 优惠价格不能大于原价
      if (this.form.diamondPrice !== null && this.form.diamondPrice !== undefined && value > this.form.diamondPrice) {
        callback(new Error(this.$t('video.discountPriceGreaterThanDiamond')))
      } else {
        callback()
      }
    },
    handleDiamondPriceChange () {
      // 当每集金币价格变化时，重新验证优惠价格
      if (this.$refs.form && this.form.discountPrice !== null && this.form.discountPrice !== undefined) {
        this.$refs.form.validateField('discountPrice')
      }
      // 同时验证自己
      if (this.$refs.form) {
        this.$refs.form.validateField('diamondPrice')
      }
    },
    handleDiscountPriceChange () {
      // 当优惠价格变化时，重新验证每集金币价格
      if (this.$refs.form && this.form.diamondPrice !== null && this.form.diamondPrice !== undefined) {
        this.$refs.form.validateField('diamondPrice')
      }
      // 同时验证自己
      if (this.$refs.form) {
        this.$refs.form.validateField('discountPrice')
      }
    },
    updateIsGo(value) {
      this.isGo = value
      // 当"是否上映"变化时，重新验证上映时间
      this.$nextTick(() => {
        if (this.$refs.form && this.form.releaseTime) {
          this.$refs.form.validateField('releaseTime')
        }
      })
    },
    validateReleaseTime (rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback()
        return
      }
      // 当"是否上映"为"否"（isRelease = 0）时，上映时间不能早于当前时间
      if (this.form.isRelease === 0 || this.form.isRelease === '0') {
        const now = new Date()
        // 将 YYYY-MM-DD HH:mm:ss 格式的字符串转换为日期对象
        const releaseDate = new Date(value.replace(/-/g, '/'))
        // 比较完整时间（包括年月日时分秒）
        if (releaseDate < now) {
          callback(new Error(this.$t('video.releaseTimeBeforeNow')))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    handleReleaseTimeChange () {
      // 当上映时间变化时，触发验证
      if (this.$refs.form) {
        this.$refs.form.validateField('releaseTime')
      }
    },
    handleChange(info) {
      const that = this
      that.uploadLoading = true
      // new UploadFileToOSS([info.file], {
      //   success: function (fileName) {
      //     console.log(fileName)
      //     that.form.coverUrl = fileName[0].url// 文件名
      //     that.uploadLoading = false
      //   }
      //
      // })

      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrl = fileName[0];//文件名
          that.uploadLoading = false;
          // 清除该字段的验证错误
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate('coverUrl')
            }
          })
        },
        error: function () {
          that.uploadLoading = false;
          that.$message.error(that.$t('video.uploadFailed'));
        }
      });
    },
    handleChange1(info) {
      const that = this
      that.uploadLoading1 = true
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlEn = fileName[0]// 文件名
          that.uploadLoading1 = false
          // 清除该字段的验证错误
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate('coverUrlEn')
            }
          })
        },
        error: function () {
          that.uploadLoading1 = false;
          that.$message.error(that.$t('video.uploadFailed'));
        }
      })
    },
    handleChange2(info) {
      const that = this
      that.uploadLoading2 = true
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlCn = fileName[0]// 文件名
          that.uploadLoading2 = false
          // 清除该字段的验证错误
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate('coverUrlCn')
            }
          })
        },
        error: function () {
          that.uploadLoading2 = false;
          that.$message.error(that.$t('video.uploadFailed'));
        }
      })
    },
    handleChange3(info) {
      const that = this
      that.uploadLoading3 = true
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlBm = fileName[0]// 文件名
          that.uploadLoading3 = false
          // 清除该字段的验证错误
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate('coverUrlBm')
            }
          })
        },
        error: function () {
          that.uploadLoading3 = false;
          that.$message.error(that.$t('video.uploadFailed'));
        }
      })
    },
    handleChange4(info) {
      const that = this
      that.uploadLoading4 = true
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.coverUrlIn = fileName[0]// 文件名
          that.uploadLoading4 = false
          // 清除该字段的验证错误
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate('coverUrlIn')
            }
          })
        },
        error: function () {
          that.uploadLoading4 = false;
          that.$message.error(that.$t('video.uploadFailed'));
        }
      })
    },
    beforeUpload: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.$t('video.uploadImage'))
        this.uploadLoading = false
        return false
      }
      this.form.coverUrl = ''
      this.uploadLoading = true
      // TODO 驗證文件大小
    },
    beforeUpload1: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.$t('video.uploadImage'))
        this.uploadLoading1 = false
        return false
      }
      this.form.coverUrlEn = ''
      this.uploadLoading1 = true
      // TODO 驗證文件大小
    },
    beforeUpload2: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.$t('video.uploadImage'))
        this.uploadLoading2 = false
        return false
      }
      this.form.coverUrlCn = ''
      this.uploadLoading2 = true
      // TODO 驗證文件大小
    },
    beforeUpload3: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.$t('video.uploadImage'))
        this.uploadLoading3 = false
        return false
      }
      this.form.coverUrlBm = ''
      this.uploadLoading3 = true
      // TODO 驗證文件大小
    },
    beforeUpload4: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.$t('video.uploadImage'))
        this.uploadLoading4 = false
        return false
      }
      this.form.coverUrlIn = ''
      this.uploadLoading4 = true
      // TODO 驗證文件大小
    },
    handleUpload(info) { // 上传主图(一张图)
      console.log(info)
      const that = this
      this.form.coverUrl = ''
      this.uploadLoading = true
      uploadCos(info.file)
    //  , function (fileName) {
    //   console.log('--------------------------------')
    //   console.log(fileName)
    //   console.log('--------------------------------')
    //   that.uploadLoading = false;
    //   that.form.coverUrl = fileName;
    // }
    },
    changeSelect(e, label, extra) {
      // 过滤掉新选择的 isOpen=0 的节点（但保留已存在的）
      const currentTagIds = this.tagIds || []
      const filteredIds = e.filter(id => {
        const node = this.treeData.find(item => item.value === id)
        // 如果节点不存在，允许保留
        if (!node) return true
        // 如果是 isOpen=0 的节点，检查是否已经在原来的 tagIds 中
        if (node.isOpen === 0) {
          return currentTagIds.includes(id)
        }
        return true
      })
      this.tagIds = filteredIds
      this.form.tagIds = filteredIds.join(',')
      // 更新 treeData 的禁用状态
      this.updateTreeDataDisabled()
    },
    getAllList() {
      listTag().then(res => {
        console.log(res.data)
        this.treeData = res.data.map(i => ({
          title: i.tagTitleIn,
          isOpen: i.isOpen,
          value: i.id,
          key: i.id,
          disabled: i.isOpen === 0
        }))
        // 如果已有 tagIds，更新禁用状态
        if (this.tagIds && this.tagIds.length > 0) {
          this.updateTreeDataDisabled()
        }
      })
    },
    updateTreeDataDisabled() {
      // 更新 treeData 的 disabled 状态
      this.treeData = this.treeData.map(item => ({
        ...item,
        disabled: item.isOpen === 0 && (!this.tagIds || !this.tagIds.includes(item.value))
      }))
    },
    onClose () {
      this.tagIds = null
      this.open = false
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        adUnlockEnabled: 0,
        lookNum: null,
        limitNum: null,
        diamondPrice: null,
        discountPrice : null,
        goldPrice: null,
        introductions: null,
        introductionsEn: null,
        introductionsCn: null,
        introductionsBm: null,
        introductionsIn: null,
        tagIds: null,
        totalNum: null,
        type: 0,
        videoName: null,
        videoNameEn: null,
        videoNameCn: null,
        videoNameBm: null,
        videoNameIn: null,
        coverUrl: null,
        coverUrlEn: null,
        coverUrlCn: null,
        coverUrlBm: null,
        coverUrlIn: null,
        createTime: null,
        remark: null,
        isRelease: 1,
        releaseTime: null,
        freeLimitNum: null
      }

      // 清除表单验证状态
      // this.$nextTick(() => {
      //   if (this.$refs.form) {
      //     this.$refs.form.clearValidate()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.getAllList()
      this.open = true
      this.updateIsGo(0)
      this.isGo = 1
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
      // this.form={
      //   id: null,
      //
      //   lookNum: null,
      //
      //   limitNum: null,
      //
      //   diamondPrice: null,
      //
      //   goldPrice: null,
      //
      //   introductions: null,
      //   introductionsEn: null,
      //
      //   tagIds: null,
      //
      //   totalNum: null,
      //
      //   videoName: null,
      //   videoNameEn: null,
      //
      //   coverUrl: null,
      //
      //   createTime: null,
      //
      //   remark: null,
      //   isRelease:1
      // }
      this.formTitle = this.$t('video.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.getAllList()
      this.formType = 2
      const id = row ? row.id : ids
      getVideo({ 'id': id }).then(response => {
        this.form = { ...response.data, adUnlockEnabled: Number(response.data.adUnlockEnabled) === 1 ? 1 : 0 }
        this.isGo = response.data.isRelease
        if (response.data.tagIds) {
          this.tagIds = response.data.tagIds.split(',')
        } else {
          this.tagIds = null
        }
        // 更新 treeData 的禁用状态，允许已存在的 isOpen=0 节点可以取消选择
        this.updateTreeDataDisabled()
        this.open = true
        this.formTitle = this.$t('video.edit')
        // 清除表单验证状态
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate()
          }
        })
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            console.log(this.form)
            updateVideo(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.tagIds = null
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addVideo(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.tagIds = null
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.upload-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.upload-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 4px;
}

.avatar-uploader {
  :deep(.ant-upload-select-picture-card) {
    width: 104px;
    height: 104px;
  }

  :deep(.ant-upload-select-picture-card:hover) {
    border-color: #1890ff;
  }
}
</style>
